import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { filter, take } from 'rxjs/operators';
import { FeatureSwitcherService } from '../../feature-switcher/feature-switcher.service';
import { FeatureFlagEnum } from '../../feature-switcher/featureFlagEnum';

@Injectable({
  providedIn: 'root',
})
export class LokaliseService {
  constructor(
    private readonly featureSwitcherService: FeatureSwitcherService,
    private readonly translate: TranslateService,
  ) {}

  init(): void {
    this.featureSwitcherService
      .isFeatureEnabledForCurrentUser(FeatureFlagEnum.interactive_translation)
      .pipe(filter(Boolean), take(1))
      .subscribe(() => {
        (window as any).LOKALISE_CONFIG.locale = this.translate.defaultLang;
        (window as any).initLiveJSForLokalise();
      });
  }
}
